import { isEmpty } from 'lodash';

export const mergeDateTime = (date: Date, time?: string) => {
  const [hours, minutes] = !isEmpty(time) ? time!.split(':') : [0, 0];

  return new Date(new Date(date).setHours(Number(hours), Number(minutes)));
};
